"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttendeeJsonMapper = exports.AttendeeDynamoMapper = void 0;
var attendee_dynamodb_1 = require("./attendee-dynamodb");
Object.defineProperty(exports, "AttendeeDynamoMapper", { enumerable: true, get: function () { return attendee_dynamodb_1.AttendeeDynamoMapper; } });
var attendee_json_1 = require("./attendee-json");
Object.defineProperty(exports, "AttendeeJsonMapper", { enumerable: true, get: function () { return attendee_json_1.AttendeeJsonMapper; } });
